import { initAuth, subscribeAuth } from './auth.js';
import { initStore, subscribeStore } from './store.js';
import { renderHeader } from './components/Header.js';
import { renderFooter } from './components/Footer.js';
import { renderHomePage } from './components/HomePage.js';
import { renderStudiesCatalog } from './components/StudiesCatalog.js';
import { renderStudyDetail } from './components/StudyDetail.js';
import { renderBlogCatalog } from './components/BlogCatalog.js';
import { renderBlogPost } from './components/BlogPost.js';
import { renderPrayTogether } from './components/PrayTogether.js';
import { renderCourseCatalog } from './components/CourseCatalog.js';
import { renderLessonDetail } from './components/LessonDetail.js';
import { renderVerseTreasury } from './components/VerseTreasury.js';
import { renderDashboard } from './components/Dashboard.js';
import { openAuthModal } from './components/AuthModal.js';

const mainContent = document.getElementById('main-content');

// Client-side router
function router() {
  const hash = window.location.hash || '#home';
  renderHeader();

  if (hash.startsWith('#join/')) {
    const inviteCode = hash.replace('#join/', '').trim();
    renderCourseCatalog(mainContent);
    openAuthModal('signup', inviteCode);
  } else if (hash.startsWith('#lesson/')) {
    const lessonId = hash.replace('#lesson/', '');
    renderLessonDetail(mainContent, lessonId);
  } else if (hash.startsWith('#study/')) {
    const studySlug = hash.replace('#study/', '');
    renderStudyDetail(mainContent, studySlug);
  } else if (hash === '#studies') {
    renderStudiesCatalog(mainContent);
  } else if (hash.startsWith('#blog/')) {
    const blogSlug = hash.replace('#blog/', '');
    renderBlogPost(mainContent, blogSlug);
  } else if (hash === '#blog') {
    renderBlogCatalog(mainContent);
  } else if (hash === '#praytogether') {
    renderPrayTogether(mainContent);
  } else if (hash === '#course') {
    renderCourseCatalog(mainContent);
  } else if (hash === '#verses') {
    renderVerseTreasury(mainContent);
  } else if (hash === '#dashboard') {
    renderDashboard(mainContent);
  } else {
    // Default to Home page (# or #home)
    renderHomePage(mainContent);
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

async function start() {
  // Check theme preference
  const savedTheme = localStorage.getItem('wt_theme') || 'dark';
  if (savedTheme === 'light') {
    document.body.classList.remove('theme-dark');
    document.body.classList.add('theme-light');
  }

  renderHeader();
  renderFooter();

  // Initialize Auth & Store
  await initAuth();
  await initStore();

  // Subscribe to updates
  subscribeAuth(() => {
    renderHeader();
    if (window.location.hash === '#dashboard') {
      renderDashboard(mainContent);
    }
  });

  subscribeStore(() => {
    router();
  });

  // Listen to hash changes
  window.addEventListener('hashchange', router);

  // Initial route execution
  router();
}

start();
